import React from "react";
import { ReactSVG } from "react-svg";
import recruiterScreenPopetjee from "../../../../../assets/images/error/recruiter-warning-popetjee.svg"
import fullSizeCloud from "../../../../../assets/images/common/extra-big-cloud.svg";
import { useAnimatedAppearence, useToast } from "../../../../../hooks";
import { ToastNotification } from "../../../../common";

const DesktopRecruiterBlockerScreen = () => {
    const { animatedContainerRef } = useAnimatedAppearence();
    const {
        toastConfig,
        toastState,
        toastMessage,
        setToastStatus,
        handleClose
    } = useToast();

    const copyEmailToClipboard = () => {
        navigator.clipboard.writeText("sales@welovehumans.io");
        setToastStatus({ success: "Email address copied to your clipboard", error: "" });
    };

    return (
        <div className="h-screen w-screen flex items-center justify-center bg-white overflow-hidden relative">
            <ToastNotification
                toastConfig={toastConfig}
                toastState={toastState}
                toastMessage={toastMessage}
                handleClose={handleClose}
            />
            <ReactSVG src={fullSizeCloud} className="opacity-50 absolute -left-[75rem] -top-[12rem] z-[1]" />
            <ReactSVG src={fullSizeCloud} className="opacity-50 absolute -right-[75rem] -top-[15rem] z-[1]" />
            <div ref={animatedContainerRef} className="text-center z-[10]">
                <h1
                    className="text-center font-bold text-[10vh] leading-[10vh] text-[#4598B1] font-[Altivo]">
                    Looks like you are <br /> a recruiting agency
                </h1>
                <div className="flex justify-center">
                    <div className="-mt-[43px] -mr-[110px]">
                        <ReactSVG src={recruiterScreenPopetjee} />
                    </div>
                </div>
                <div className="mt-[59.56px] text-center font-bold text-[25px] leading-[30px] text-[#344266] font-[Altivo]">
                    Please contact {" "}
                    <span onClick={copyEmailToClipboard} className="font-bold text-[25px] leading-[30px] text-[#344266] cursor-pointer underline decoration-solid no-underline-offset font-[Altivo] hover:text-light-purple active:text-black">
                        sales@welovehumans.io
                    </span> {" "}
                    to <br /> see what we can do for you
                </div>
            </div>
        </div>
    );
};
export default DesktopRecruiterBlockerScreen
